import React from 'react'
import { index } from '../../../store/actions/pixel.action'
import { index as indexGoogle } from '../../../store/actions/google.action'
import { change, show, store, update, success as changeSuccess } from '../../../store/actions/links.action'
import { CircularProgress, FormControl, FormControlLabel, Radio, RadioGroup, TextField, AppBar, Toolbar, IconButton, Typography, Button } from '@material-ui/core'
import { FaSave } from 'react-icons/fa'
import { MdKeyboardBackspace } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreenB } from '../../../store/actions/navigation.action'


export default function LinksEdit(props) {
    const dispatch = useDispatch()
    const { link, error } = useSelector(state => state.linksReducer)
    const { pixels } = useSelector(state => state.pixelReducer)
    const { tags } = useSelector(state => state.googleReducer)
    
    const id = (props.uid) ? props.uid : null;
    const campaign_id = (props.campaign_id) ? props.campaign_id : null;

    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        dispatch(index())
        dispatch(indexGoogle())

        if (id) {
            dispatch(show(id)).then(res => res && setLoading(false))
        } else {
            dispatch(change({
                'campaign_id' : null,
                'title' : '',
                'pixel' : '',
                'pixel_access_token' : '',
                'pixel_id' : null,
                'google_tag_id' : null
            }))
            setLoading(false)
        }
        return () => {
            dispatch(change('clear'))
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _save = () => {
        if(id) {
            dispatch(update(link))
        } else {
            dispatch(store({
                'campaign_id' : campaign_id,
                'title' : link.title,
                'pixel' : link.pixel,
                'pixel_access_token' : link.pixel_access_token,
                'pixel_id' : link.pixel_id,
                'google_tag_id': link.google_tag_id
            }))
        }
    }

    return (
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreenB({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        {(id) ? 'Editar Link' : 'Novo Link'}
                    </Typography>

                    <Button onClick={() => _save() } color="inherit" className="ms-auto">
                        <FaSave className="me-2" /> Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card card-body mt-3 bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Titulo</label>
                            <TextField
                                error={(error.title) && true}
                                value={link.title || ''}
                                placeholder="Ex: Link Campanha Instagram"
                                onChange={text => {
                                    dispatch(change({ title: text.target.value }))
                                    if (error.title && delete error.title);
                                }}
                            />

                            {(error.title) &&
                                <strong className="text-danger">{error.title[0]}</strong>
                            }
                        </div>

                        <hr className="invisible hr-muted"/>

                        {(pixels.data.length > 0) &&
                            <div className="mb-4">
                                <label className="label-custom d-block bs-color-b">API Conversão</label>
                                <FormControl component="fieldset">
                                    <RadioGroup 
                                        aria-label="pixel_id" 
                                        name="pixel_id" 
                                        value={link.pixel_id} 
                                        onChange={ e => dispatch(change({ pixel_id: parseInt(e.target.value) }))}
                                        className="fw-normal bs-color-b"
                                    >
                                        {pixels.data.map((item, index) => (
                                            <FormControlLabel key={index} value={item.id} control={<Radio color="primary" />} label={item.title} />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        }

                        {(tags.data.length > 0) &&
                            <div className="mb-4">
                                <label className="label-custom d-block bs-color-b">Google Tag Manager</label>
                                <FormControl component="fieldset">
                                    <RadioGroup 
                                        aria-label="tag_id" 
                                        name="tag_id" 
                                        value={link.google_tag_id} 
                                        onChange={ e => dispatch(change({ google_tag_id: parseInt(e.target.value) }))}
                                        className="fw-bold bs-color-b"
                                    >
                                        {tags.data.map((item, index) => (
                                            <FormControlLabel key={index} value={item.id} control={<Radio color="primary" />} label={item.title} />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        }
                    </div>
                </>
            }
        </div>
    )
}